import React from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import TitlePage from "../../../../components/TitlePage";
import { formatOptionsToArray } from "../../../../../utils/utils";
import Card from "../../../../components/Card";
import AccordionHistory from "../../../../components/AccordionHistory";
import Pagination from "../../../../components/Pagination";
import LoadingSection from "../../../../components/LoadingSection";

export default function HistoryVisitComponent({
  dataHistory,
  isLoading = false,
  totalPage = 0,
  totalEntries = 0,
  activePage,
  sizePerPage,
  handlePagination,
  itemData = null,
  handleSizePerPage,
}) {
  const history = useHistory();

  if (isLoading) {
    return (
      <Card header={<TitlePage isBack text="Riwayat Kunjungan" />}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            minHeight: 500,
            alignItems: "center",
          }}
        >
          <LoadingSection />
        </div>
      </Card>
    );
  }

  return (
    <Card
      header={
        <TitlePage
          isBack
          text={
            itemData &&
            `${itemData?.name}, ${itemData?.gender?.toLowerCase()}, ${
              itemData?.dob
            }`
          }
        />
      }
    >
      <div style={{ display: "flex", gap: 12, flexDirection: "column" }}>
        {dataHistory.map((item, index) => (
          <AccordionHistory
            key={index}
            visitId={item?.id}
            date={moment(item?.start).format("DD MMM YYYY")}
            diagnoses={formatOptionsToArray(item?.diagnosisJson || [])}
            doctorName={item?.practitionerName}
            anamnesis={item?.anamnesis}
            physicalExamination={item?.examination}
            uploadedFiles={item?.fileUploads || []}
            onClickDetail={() =>
              history.push({
                pathname: "/active-visit/assesment",
                search: `?id=${item?.id}&patientId=${item?.patient?.id}`,
                state: { isView: true },
              })
            }
          />
        ))}
        <Pagination
          activePage={activePage}
          totalPage={totalPage}
          totalShow={dataHistory.length}
          totalEntries={totalEntries}
          handlePagination={handlePagination}
          handleSizePerPage={handleSizePerPage}
          sizePerPage={sizePerPage}
        />
      </div>
    </Card>
  );
}
